import { Checkbox, type CheckboxProps } from '@mantine/core'
import { type FC } from 'react'

export interface CheckboxInputProps extends CheckboxProps {}

export const CheckboxInput: FC<CheckboxInputProps> = (checkboxProps) => <Checkbox {...checkboxProps} />
